import { Component, type ErrorInfo, type ReactNode, type CSSProperties } from 'react';

interface Props { children: ReactNode }
interface State { error: Error | null }

// Red de seguridad de último recurso: sin esto, cualquier excepción no capturada en el
// árbol de render (p.ej. bajo un re-render pesado o un dato con forma inesperada)
// desmonta TODA la app a blanco, sin ninguna pista de qué pasó ni forma de recuperarse.
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };
  static getDerivedStateFromError(error: Error): State {
    return { error };
  }
  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }
  override render() {
    if (this.state.error) {
      return (
        <div style={wrap} data-testid="error-boundary">
          <h2 style={{ margin: '0 0 6px' }}>Algo salió mal</h2>
          <p style={{ color: 'var(--lumal-muted)', margin: '0 0 16px' }}>
            Ocurrió un error inesperado en esta pantalla. Recarga para continuar.
          </p>
          <button type="button" style={btn} data-testid="error-boundary-reload"
            onClick={() => globalThis.location?.reload()}>
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const wrap: CSSProperties = {
  maxWidth: 440, margin: '15vh auto', padding: '1.5rem', textAlign: 'center',
  background: 'var(--lumal-surface)', border: '1px solid var(--lumal-border)',
  borderRadius: 'var(--lumal-radius, 10px)', boxShadow: 'var(--lumal-shadow-md)',
};
const btn: CSSProperties = {
  padding: '0.5rem 1.2rem', borderRadius: 'var(--lumal-radius-sm, 7px)', border: 'none',
  background: 'var(--lumal-primary)', color: 'var(--lumal-primary-fg, #fff)', fontWeight: 650, cursor: 'pointer',
};
